import { ModuleWithProviders, NgModule } from '@angular/core'
import { TimeRangeService } from '@ftr/ui-playback'
import { OrderService } from './order.service'

@NgModule({
  providers: [OrderService],
})
export class OrderServiceModule {
  static forRoot(): ModuleWithProviders<OrderServiceModule> {
    return {
      ngModule: OrderServiceModule,
      providers: [TimeRangeService],
    }
  }
}
